// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vzd-search-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
  backdrop-filter: blur(2px);
}

.vzd-search-modal {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  width: 90vw;
  max-width: 700px;
  height: 80vh;
  max-height: 650px;
  display: flex;
  flex-direction: column;
  font-family: 'Roboto', sans-serif;
  overflow: hidden;
}

.vzd-search-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  position: relative;
  flex-shrink: 0;
}

.vzd-search-header h2 {
  margin: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.vzd-search-close {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: #4A4A4A;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #FFFFFF;
  padding-top: 3px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.vzd-search-close:hover {
  background: #333333;
}

/* Tabs */
.vzd-search-tabs {
  display: flex;
  padding: 0 24px;
  gap: 0;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.vzd-search-tab {
  flex: 1;
  padding: 12px 16px;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: color 0.2s, border-color 0.2s;
}

.vzd-search-tab:hover {
  color: #333;
}

.vzd-search-tab.active {
  color: var(--netsfere-red);
  border-bottom-color: var(--netsfere-red);
}

/* Search area */
.vzd-search-area {
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.vzd-search-input-row {
  display: flex;
  gap: 8px;
}

.vzd-search-input {
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  outline: none;
  transition: border-color 0.2s;
}

.vzd-search-input:focus {
  border-color: var(--netsfere-red);
}

.vzd-search-button-action {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background-color: var(--netsfere-red);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
}

.vzd-search-button-action:hover:not(:disabled) {
  background-color: #b82419;
}

.vzd-search-button-action:disabled {
  background-color: #ed9a9a;
  cursor: not-allowed;
}

/* Advanced toggle */
.vzd-advanced-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 4px 0;
  border: none;
  background: none;
  font-size: 13px;
  color: #666;
  cursor: pointer;
}

.vzd-advanced-toggle:hover {
  color: #333;
}

.vzd-advanced-toggle ion-icon {
  font-size: 16px;
}

/* Advanced fields */
.vzd-advanced-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.vzd-field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.vzd-field-group label {
  font-size: 12px;
  font-weight: 500;
  color: #555;
}

.vzd-field-group input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  outline: none;
}

.vzd-field-group input:focus {
  border-color: var(--netsfere-red);
}

/* Results area */
.vzd-search-results-area {
  flex: 1;
  overflow-y: auto;
  padding: 16px 24px;
  min-height: 0;
}

.vzd-search-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background-color: #fff8e1;
  border: 1px solid #ffc107;
  border-radius: 8px;
  color: #856404;
  font-size: 14px;
}

.vzd-search-error ion-icon {
  font-size: 20px;
  color: #ff9800;
  flex-shrink: 0;
}

.vzd-search-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #999;
}

.vzd-search-empty ion-icon {
  font-size: 48px;
}

/* Footer */
.vzd-search-footer {
  display: flex;
  justify-content: center;
  padding: 12px 24px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.vzd-search-done-button {
  padding: 8px 28px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background-color: var(--netsfere-red);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.vzd-search-done-button:hover {
  background-color: #b82419;
}

@media (max-width: 600px) {
  .vzd-search-modal {
    width: 95vw;
    height: 90vh;
    max-height: none;
    border-radius: 8px;
  }

  .vzd-search-input-row {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VzdSearch/VzdSearchModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".vzd-search-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 4000;\n  backdrop-filter: blur(2px);\n}\n\n.vzd-search-modal {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  width: 90vw;\n  max-width: 700px;\n  height: 80vh;\n  max-height: 650px;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Roboto', sans-serif;\n  overflow: hidden;\n}\n\n.vzd-search-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.vzd-search-header h2 {\n  margin: 0;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.vzd-search-close {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #4A4A4A;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #FFFFFF;\n  padding-top: 3px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.vzd-search-close:hover {\n  background: #333333;\n}\n\n/* Tabs */\n.vzd-search-tabs {\n  display: flex;\n  padding: 0 24px;\n  gap: 0;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.vzd-search-tab {\n  flex: 1;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: color 0.2s, border-color 0.2s;\n}\n\n.vzd-search-tab:hover {\n  color: #333;\n}\n\n.vzd-search-tab.active {\n  color: var(--netsfere-red);\n  border-bottom-color: var(--netsfere-red);\n}\n\n/* Search area */\n.vzd-search-area {\n  padding: 16px 24px;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.vzd-search-input-row {\n  display: flex;\n  gap: 8px;\n}\n\n.vzd-search-input {\n  flex: 1;\n  padding: 10px 14px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: 'Roboto', sans-serif;\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.vzd-search-input:focus {\n  border-color: var(--netsfere-red);\n}\n\n.vzd-search-button-action {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  background-color: var(--netsfere-red);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n}\n\n.vzd-search-button-action:hover:not(:disabled) {\n  background-color: #b82419;\n}\n\n.vzd-search-button-action:disabled {\n  background-color: #ed9a9a;\n  cursor: not-allowed;\n}\n\n/* Advanced toggle */\n.vzd-advanced-toggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n  padding: 4px 0;\n  border: none;\n  background: none;\n  font-size: 13px;\n  color: #666;\n  cursor: pointer;\n}\n\n.vzd-advanced-toggle:hover {\n  color: #333;\n}\n\n.vzd-advanced-toggle ion-icon {\n  font-size: 16px;\n}\n\n/* Advanced fields */\n.vzd-advanced-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.vzd-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.vzd-field-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #555;\n}\n\n.vzd-field-group input {\n  padding: 8px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: 'Roboto', sans-serif;\n  outline: none;\n}\n\n.vzd-field-group input:focus {\n  border-color: var(--netsfere-red);\n}\n\n/* Results area */\n.vzd-search-results-area {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 24px;\n  min-height: 0;\n}\n\n.vzd-search-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n  background-color: #fff8e1;\n  border: 1px solid #ffc107;\n  border-radius: 8px;\n  color: #856404;\n  font-size: 14px;\n}\n\n.vzd-search-error ion-icon {\n  font-size: 20px;\n  color: #ff9800;\n  flex-shrink: 0;\n}\n\n.vzd-search-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n  color: #999;\n}\n\n.vzd-search-empty ion-icon {\n  font-size: 48px;\n}\n\n/* Footer */\n.vzd-search-footer {\n  display: flex;\n  justify-content: center;\n  padding: 12px 24px;\n  border-top: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.vzd-search-done-button {\n  padding: 8px 28px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  background-color: var(--netsfere-red);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.vzd-search-done-button:hover {\n  background-color: #b82419;\n}\n\n@media (max-width: 600px) {\n  .vzd-search-modal {\n    width: 95vw;\n    height: 90vh;\n    max-height: none;\n    border-radius: 8px;\n  }\n\n  .vzd-search-input-row {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
